<template>
  <el-container>
    <el-header>
      <MenuLogo />
      <div>
        <router-link :to="{ name: 'demo'}">
          <el-button type="primary" class="first-button">Try Demo</el-button>
        </router-link>
        <router-link :to="{ name: 'login'}">
          <el-button type="primary" plain>Login</el-button>
        </router-link>
      </div>
    </el-header>
    <el-main>
      <div class="presentation">
        <div class="texts">
          <h1>
            <!-- Stop guessing what's in HTTP payloads that flow into your servers,
            <u>see them</u>.-->
            Visualize clearly full
            <u>payloads</u> of requests clients make to
            <u>your APIs</u>.
          </h1>
          <h2
            class="subtitle"
          >Say goodbye to clueless white on black lines of json logs in the console</h2>
          <div>
            <router-link :to="{ name: 'demo'}">
              <el-button type="primary" plain class="first-button">Try Demo</el-button>
            </router-link>
            <a
              href="mailto:po@drhttp.com?subject=Beta%20acess%20request&body=Hi%2C%0D%0AMy%20name%20is%20%3Cinsert_your_name_here%3E%0D%0AI%27d%20like%20a%20beta%20access%20to%20Dr.%20Ashetetepe.%0D%0ACheers%20%21"
              @click.capture="trackRequestBeta()"
            >
              <el-button type="primary">Request beta access</el-button>
            </a>
          </div>
        </div>
        <img class="video" :src="require('@/assets/images/demo-screencast.gif')" />
      </div>
      <h3 class="sdks-title">DrHTTP integrates seamlessly with the following technologies :</h3>
      <SdksList />
    </el-main>
  </el-container>
</template>

<script>
import axios from "axios";

import MenuLogo from "@/components/MenuLogo.vue";
import SdksList from "@/components/SdksList.vue";

export default {
  components: {
    MenuLogo,
    SdksList
  },
  data: function() {
    return {
      api_key: localStorage.getItem("trial_api_key")
    };
  },
  methods: {
    trackRequestBeta() {
      this.$matomo.trackEvent("Onboarding", "Request beta");
    }
  },
  mounted() {
    if (!this.api_key) {
      axios({
        url: "/api/v1/project/generate_trial_api_key/",
        method: "GET"
      }).then(resp => {
        this.api_key = resp.data.api_key;
        localStorage.setItem("trial_api_key", this.api_key);
      });
    }
  }
};
</script>

<style scoped lang="sass">

.el-header
  @include flex($h: space-between, $v: center)
  flex-wrap: wrap

.el-main
  @include flex($h: flex-start, $v: center)
  flex-direction: column

.presentation
  @include flex($h: center, $v: center)
  flex-wrap: wrap

  > *
    @include margin($h: 10px)
    width: 500px

  .texts
    @include flex($h: space-between, $v: flex-start)
    flex-direction: column
    flex-wrap: wrap

    h2
      font-weight: normal

  .video
    height: 300px
    border-radius: 5px
    @include margin($v: 10px)
    @include shadow()

.first-button
  margin-right: 10px

.sdks-title
  margin-top: 100px

</style>